/*
  Sold-out cache fallback.

  Why this exists: Shopify edge CDN sometimes serves stale HTML where a
  product is rendered as "sold out" even though the current inventory is
  in stock (especially after inventory or status changes). The Liquid is
  correct on a fresh render; the issue is only stale cached HTML reaching
  some shoppers.

  How it works:
    1. For every product card and the main product form on the page that
       is currently rendered as sold out, we look up the product handle.
    2. We query Shopify's authoritative /products/{handle}.js endpoint
       (never cached by us, always reflects current state).
    3. If the live response says the product is available, we remove the
       sold-out badge and re-enable the button.
    4. If the live response confirms sold out, we do nothing.

  Safety: this script can only RELAX sold-out state, never add it. If the
  network fails or the response is unexpected, the page is left as-is.
*/
(function () {
  if (window.__sgSoldOutFallback) return;
  window.__sgSoldOutFallback = true;

  var SOLD_OUT_TEXTS = ['sold out', 'sold-out', 'unavailable'];
  var handleCache = {};

  function extractHandle(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function fetchProduct(handle) {
    if (handleCache[handle]) return handleCache[handle];
    handleCache[handle] = fetch('/products/' + handle + '.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return handleCache[handle];
  }

  function looksSoldOut(text) {
    if (!text) return false;
    var t = String(text).trim().toLowerCase();
    return SOLD_OUT_TEXTS.some(function (s) { return t.indexOf(s) !== -1; });
  }

  function clearBadge(card) {
    try {
      card.querySelectorAll('.badge').forEach(function (b) {
        if (looksSoldOut(b.textContent)) b.remove();
      });
    } catch (e) {}
  }

  function reenableButton(btn) {
    if (!btn) return;
    try {
      btn.removeAttribute('disabled');
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('disabled');
      var span = btn.querySelector('span:not(.svg-wrapper):not(.sold-out-message)');
      if (span && looksSoldOut(span.textContent) && window.variantStrings) {
        span.textContent = window.variantStrings.addToCart || 'Buy now';
      }
    } catch (e) {}
  }

  function checkCards() {
    var cards = document.querySelectorAll(
      '.card-wrapper, .card, product-card, .product-card-wrapper'
    );
    cards.forEach(function (card) {
      var badge = card.querySelector('.badge');
      if (!badge || !looksSoldOut(badge.textContent)) return;

      var link = card.querySelector('a[href*="/products/"]');
      var handle = link && extractHandle(link.getAttribute('href'));
      if (!handle) return;

      fetchProduct(handle).then(function (product) {
        if (!product || product.available !== true) return;
        clearBadge(card);
        var btn = card.querySelector('button[name="add"], .product-form__submit');
        reenableButton(btn);
      });
    });
  }

  function checkMainProduct() {
    var form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (!form) return;
    var submit = form.querySelector('button[name="add"], .product-form__submit');
    if (!submit) return;

    var span = submit.querySelector('span');
    var disabled = submit.hasAttribute('disabled') || submit.getAttribute('aria-disabled') === 'true';
    if (!disabled && (!span || !looksSoldOut(span.textContent))) return;

    var handle = extractHandle(window.location.pathname);
    if (!handle) return;

    fetchProduct(handle).then(function (product) {
      if (!product || product.available !== true) return;
      var variantInput = form.querySelector('input[name="id"]');
      var variantId = variantInput && parseInt(variantInput.value, 10);
      var liveVariant = product.variants.find(function (v) { return v.id === variantId; })
        || product.variants.find(function (v) { return v.available; });
      if (!liveVariant || !liveVariant.available) return;
      if (variantInput && !variantInput.value) variantInput.value = liveVariant.id;
      variantInput && variantInput.removeAttribute('disabled');
      reenableButton(submit);
    });
  }

  function run() {
    try { checkCards(); } catch (e) {}
    try { checkMainProduct(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function () { run(); });
})();
